import { DataBean } from "../DataBean";

export class DashBoard extends DataBean {



    public async getDashBoardCatalog(processType: any, state: any, regexStr: any, idAccount: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getDashBoardCatalog_Number_Number_String_Number_Number_Number", [processType, state, regexStr, idAccount, page, recordsPerPage]);
    }
    public async getDashBoardCatalogByKpi(idKpi: any, processType: any, state: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getDashBoardCatalogByKpi_Number_Number_Number_String_Number_Number", [idKpi, processType, state, regexStr, page, recordsPerPage]);
    }
    public async deleteDashBoard(idDashBoard: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteDashBoard_Number", [idDashBoard]);
    }

    public async updateDashBoard(bean): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_updateDashBoard_com.quickdataerp.bean.bi.DashBoard", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.bi.DashBoard"
            }
        ]);
    }
    public async getDashBoardInfo(idDashBoard:number,xLength:number,yLength:number,idEmployee:number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getDashBoardInfo_Number_Number_Number_Number", [
           idDashBoard,xLength,yLength,idEmployee
        ]);
    }
    public async getKpiMeasurementTableForDashBoard(idKpi:number,xLength:number,yLength:number,idEmployee:number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getKpiMeasurementTableForDashBoard_Number_Number_Number_Number", [
           idKpi,xLength,yLength,idEmployee
        ]);
    }
    public async getDashBoardInfoForAccount(idAccount:number,dashBoardItems:number,xLength:number,yLength:number,idEmployee:number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getDashBoardInfoForAccount_Number_Number_Number_Number_Number", [
           idAccount,dashBoardItems,xLength,yLength,idEmployee
        ]);
    }

}